export const APP_ROOT_ID = "app-root";
export const PORTAL_ROOT_ID = APP_ROOT_ID;

export const COOR_ID = "15FB23A7-AFE3-4CE7-AD3E-A19385CCBEF2";
